import { Widget, WIDGET_TIMELINE, TimeoutEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";

export class TimelineWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#timelineWidget';
        super(options);

        this.name = 'widgettimeline';
        this.widgetName = options.widgetName || WIDGET_TIMELINE;
        this.widgetName = this.product + this.widgetName;


        this.widget = null;

        if (options.selectedChannel){
            this.widgetOptions = {
                channel: options.selectedChannel,
                selectedChannel: options.selectedChannel
            };
        }else{
            this.widgetOptions = {
                channel: srvg.videooptions.defaultchannel || 0,
                selectedChannel: srvg.videooptions.defaultchannel || 0,
            };
        }
        this.widgetOptions['height'] = this.getContainerHeightWithUnit();
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addTimelineWidget();
        super.handleDomInstantiated();
    }

    /**
     * add timeline widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addTimelineWidget(selector?) {
        var that = this;
        selector = selector || this.selector;
        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addTimelineWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addTimelineWidget(element);
    }

    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    setChannel(channel: number){
        // FIXME replace with this.setOption( 'channel', channel );
        if(this.widget && this.widget.api){
            this.widget.api.setChannel(channel);
        }
    }

    // destroy the widget for inactivity
    handleTimeoutEvent(event: TimeoutEvent, provider){
        this.destroyWidget(this.widget, this.name);
    }

    handleChannelSwitchEvent(event: ChannelSwitchEvent, provider){
        this.widgetOptions.selectedChannel = event.newChannel;
        this.widgetOptions.channel = event.newChannel;
        this.setChannel(event.newChannel);
    }

}
